var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{attrs:{"series":_vm.series,"categories":_vm.categories},on:{"lineClicked":_vm.onSelectedDateonGraph}})}
var staticRenderFns = []

export { render, staticRenderFns }